import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { spotPriceLoader } from "@/lib/spotSnapshot";

const ElpriserImorgon = lazy(() => import("@/pages/elpriser/Imorgon"));

export const Route = createFileRoute("/elpriser/imorgon")({
  // Spotpriserna hämtas på servern så att tabeller och nyckeltal finns i HTML:en.
  loader: spotPriceLoader,
  head: () => seoHead("/elpriser/imorgon", { description: "Se morgondagens elpriser timme för timme i SE1, SE2, SE3 och SE4. Priserna publiceras cirka kl 13:30–14:00 från Nord Pool." }),
  component: () => <ElpriserImorgon />,
});
